
function pulsateDots() {
    document.querySelectorAll('.map__wrapper .circle').forEach((elem, index) => {
        //let rand = Math.floor(Math.random() * 10);
        let random = parseFloat(index / 4);
        //let decimal = (parseFloat(1.5) - parseFloat(`0.${index+rand}`));
        elem.classList.add('show');
        if(index > 0) {
            elem.style.animationDelay = `${random}s`
        } 
        //elem.style.animationDuration = `${decimal}s`
        function startanimation(element) {
            element.classList.add("animate");
        }
        setInterval(() => {
            startanimation(elem);
        }, 1100)
        startanimation(elem);

        elem.addEventListener( "animationend",  function() {
            elem.classList.remove("animate");  	
        } );
    })
}

placementDots();
pulsateDots();

function placementDots() {

    let position = [{
        "x": "10.5%",
        "y": "42.5%"
    },
    {
        "x": "22%",
        "y": "34.1%"
    },
    {
        "x": "22.1%",
        "y": "53.2%"
    },
    {
        "x": "28.5%",
        "y": "38.3%"
    },
    {
        "x": "45.2%",
        "y": "36.3%"
    },
    {
        "x": "91.6%",
        "y": "84.8%"
    }]

    if(screen.availWidth <= 550) {
        position = [{
            "x": "9.4%",
            "y": "43.1%"
        },
        {
            "x": "21.4%",
            "y": "34.5%"
        },
        {
            "x": "21.3%",
            "y": "54%"
        },
        {
            "x": "27.9%",
            "y": "38.8%"
        },
        {
            "x": "45.1%",
            "y": "36.8%"
        },
        {
            "x": "92.7%",
            "y": "86.1%"
        }]
    } else if(screen.availWidth <= 992) {
        position = [{
            "x": "9.8%",
            "y": "43.4%"
        },
        {
            "x": "21.6%",
            "y": "34.7%"
        },
        {
            "x": "21.6%",
            "y": "54.1%"
        },
        {
            "x": "28.18%",
            "y": "39.1%"
        },
        {
            "x": "45.2%",
            "y": "36.95%"
        },
        {
            "x": "92.4%",
            "y": "86.3%"
        }]
    }
    document.querySelectorAll('.map__wrapper .circle').forEach((elem, index) => {
        elem.style.left = position[index].x;
        elem.style.top = position[index].y;
    })
}
window.addEventListener("resize", () => {
    placementDots()
});

function readMore() {
    const readMore = document.querySelectorAll('.read-more');
    if(readMore.length > 0) {
        readMore.forEach((elem) => {
            elem.addEventListener('click', () => {
                elem.closest(".image__wrap").classList.toggle("expand");
            })
        })
        const close = document.querySelectorAll('.close-desc');
        close.forEach((elem) => {
            elem.addEventListener('click', () => {
                elem.closest(".image__wrap").classList.toggle("expand");
            })
        })
    }
}
readMore();
